module.exports = __webpack_public_path__ + "img/631.44987268.png";